














































import { computed, defineComponent } from "@vue/composition-api";
import { intervalToDuration } from "date-fns";
import { Appointment } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import {
  AppointmentTypeKind,
  AppointmentTypeList,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { formatDate } from "@/lib/time";
import { QuickTip } from "@/types";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInput from "@/components/BaseInput";
import QuickTipsItem from "@/components/QuickTipsItem";
import UserBadgeWithAvatar from "@/components/UserBadgeWithAvatar";
import { AppointmentsTabNameEnum } from "@/views/PageAppointments/config";

export default defineComponent({
  name: "UserConfirmBookingModal",
  components: {
    BaseInput,
    UserBadgeWithAvatar,
    QuickTipsItem,
    BaseButton,
    BaseAvatar,
    BaseConfirm,
  },
  props: {
    appointment: { type: Object as () => Appointment, required: true },
    appointmentTypes: { type: Object as () => AppointmentTypeList, required: true },
  },
  setup(props) {
    const refundTip: QuickTip = {
      icon: "sci-lock-line",
      translateKey: "If the creator can't fulfill your request, you'll receive a full refund",
    };
    const selectedSlotTime = computed(() => {
      return `${formatDate(new Date(props.appointment.startTime), {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).toLowerCase()} - ${formatDate(new Date(props.appointment.endTime), {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).toLowerCase()}`;
    });
    const durationAndCost = computed(() => {
      const { hours, minutes } = intervalToDuration({
        start: new Date(props.appointment.startTime),
        end: new Date(props.appointment.endTime),
      });
      return `${hours && hours > 0 ? hours + "h" : ""} ${
        minutes && minutes > 0 ? minutes + "m" : ""
      }, ${formatMoneyString(props.appointment.amount)}`;
    });
    const getAppointmentTypeName = computed(() => {
      switch (props.appointment.typeKind) {
        case AppointmentTypeKind.MESSAGING:
          return $t("Chat");
        case AppointmentTypeKind.VIDEO_CALLS:
          return $t("Video call");
        case AppointmentTypeKind.AUDIO_CALLS:
          return $t("Audio call");
        case AppointmentTypeKind.TOUR_GUIDE:
          return $t("Offline meeting");
        default:
          return "";
      }
    });
    return {
      refundTip,
      durationAndCost,
      selectedSlotTime,
      getAppointmentTypeName,
      AppointmentsTabNameEnum,
      AppointmentTypeKind,
    };
  },
});
